'use strict';

var windowManager = require('./window-manager');

var getPublicDomain = function() {
  return windowManager.get().location.hostname.split('.').slice(1).join('.');
};

module.exports = getPublicDomain;
